module.exports = "/currency/assets/b9e3355e8697e593268d3e7bb30181ae.png";